import { Mark } from 'tiptap'
import { toggleMark } from 'prosemirror-commands'

export default class HighlightMarkTeal extends Mark {
    get name () {
        return 'highlight_mark_teal'
    }
    get schema () {
        return {
            attrs: {
                color: {
                    default: 'rgba(32, 129, 141, 1)',
                }
            },
            parseDOM: [
                {
                    style: 'color',
                    getAttrs (value) {
                        return { color: value }
                    }
                }
            ],
            toDOM (mark) {
                let { color } = mark.attrs
                return ['span', { style: `color: ${color}` }, 0]
            }
        };
    }
    commands ({ type }) {
        return attrs => toggleMark(type, attrs)
    }
}
